// extracted by mini-css-extract-plugin
export default {"panel":"MentionInput_panel__fOwmS","item":"MentionInput_item__Gei1Z","itemActive":"MentionInput_itemActive__jThLP","itemEmail":"MentionInput_itemEmail__uIDNG"};